<app-header-navigation-bar></app-header-navigation-bar>
<section class="hero" [class.hero--accent]="accent">
    <div class="hero-inner">
        <h1 class="hero-title">{{ title }}</h1>
        <p class="hero-sub" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
</section>
